<template>
    <div :class="{'full-screen': isServiceDown}">
        <div
            class="content"
        >
            <header-bar class="header-bar" />
            <div
                class="main-container"
                :class="{
                    'disable-component': isServiceDown
                }"
            >
                <info-box class="info-box" />
                <referrer-form class="referrer-form" @customerNotFound="showPopup = true" />
            </div>
            <popup
                :show="showPopup"
                :class="{
                    'disable-component': isServiceDown
                }"
            />
            <small
                class="disclaimer"
                :class="{
                    'disable-component': isServiceDown
                }"
            >
                {{ $t('disclaimer') }}
            </small>
        </div>
        <service-down v-if="isServiceDown" />
    </div>
</template>

<script>
    import InfoBox from '@/components/InfoBox'
    import ReferrerForm from '@/components/ReferrerForm'
    import Popup from '@/components/Popup'
    import HeaderBar from '@/components/HeaderBar'
    import ServiceDown from '@/components/ServiceDown'
    export default {
        name: 'HomeRoute',
        components: {
            InfoBox,
            ReferrerForm,
            Popup,
            HeaderBar,
            ServiceDown
        },
        data() {
            return {
                showPopup: false,
                isServiceDown: process.env.VUE_APP_SERVICE_DOWN
            }
        }
    }
</script>

<style scoped>
.full-screen {
    height: 100vh;
    overflow: hidden;
}
.disable-component {
    opacity: 0;
    pointer-events: none;
    user-select: none;
}
.content {
    width: 90%;
    margin: 0 auto;
    height: 100vh;
}
.head-bar {
    z-index: 1;
}
.main-container {
    display: flex;
    flex-direction: column;
}
.info-box {
    margin-bottom: 1rem;
    margin-bottom: 80px;
}
.referrer-form {
    margin-bottom: 1rem;
}
.disclaimer {
    text-shadow: 0 0 5px rgb(0 0 0);
    font-size: 1rem;
    font-weight: 500;
    margin-left: 1rem;
    margin-top: .5rem;
    display: inline-block;
    color: #fff;
}
@media screen and (min-width: 1281px) {
    .content {
        height: 100vh;
    }
    .main-container {
        display: flex;
        flex-direction: row;
    }
    .info-box {
        margin-bottom: 0;
        margin-right: 2rem;
    }
    .referrer-form {
        margin-bottom: 0;
    }
}

@media screen and (max-width: 1500px) {
    .info-box {
        margin-right: 40px;
    }
}
@media screen and (max-width: 700px) {
    .info-box {
        margin-bottom: 20px;
    }
}
@media screen and (max-width: 500px) {
    .info-box {
        margin-bottom: 10px;
    }
}
</style>
